import { SPECTRUM_PAGE } from '@/common/constants/pages';
import Notifier from '@/common/services/Notifier';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { DriveTreeItem } from '@/drive/entities/DriveTreeItem/DriveTreeItem';
import ForwardNotification from '@/forwarding/components/ForwardNotification/ForwardNotification';

export class ForwardNotificationService {
  static addedToSpectrumSuccess(itemId: DriveItemId) {
    const url = `${SPECTRUM_PAGE}?n=${itemId}`;

    Notifier.success(<ForwardNotification title="Added to Light-Spectrum Demo" url={url} />, { isClosedOnClick: false });
  }

  static addedSuccess(destination: DriveTreeItem) {
    Notifier.success(<ForwardNotification title="Added" url={destination.getUrl()} />, { isClosedOnClick: false });
  }

  static movedSuccess(destination: DriveTreeItem) {
    Notifier.success(<ForwardNotification title="Moved" url={destination.getUrl()} />, { isClosedOnClick: false });
  }
}
